/**
 * Created by Victor Rojo on 6/9/19.
 */
import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  tenant: string = 'smartpadel';
}
